import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry, Sentry } from './lib/sentry';
import App from './app/App';
import TestApp from './app/TestApp';
import './styles/global.css';

initSentry();

const isTestMode = !window.Twitch?.ext;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="error">Something went wrong.</div>}>
      {isTestMode ? <TestApp /> : <App />}
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
